import React from "react";
import "./style.css";

const MatchStats = ({ match, playerStats, matchResults }) => {
  const cards = playerStats.reduce(
    (acc, stat) => {
      const teamName = stat.team?.team_name || "Unknown";
      acc.red[teamName] = (acc.red[teamName] || 0) + (stat.red_card || 0);
      acc.yellow[teamName] = (acc.yellow[teamName] || 0) + (stat.yellow_card || 0);
      acc.ownGoals[teamName] = (acc.ownGoals[teamName] || 0) + (stat.goal_to_himself || 0);
      return acc;
    },
    { red: {}, yellow: {}, ownGoals: {} }
  );

  const statsList = [
    {
      label: "Topla Oynama %",
      team1: match.first_team_percentage,
      team2: match.second_team_percentage,
    },
    {
      label: "Kırmızı Kart",
      team1: cards.red[match.first_team_name] || 0,
      team2: cards.red[match.second_team_name] || 0,
    },
    {
      label: "Sarı Kart",
      team1: cards.yellow[match.first_team_name] || 0,
      team2: cards.yellow[match.second_team_name] || 0,
    },
    {
      label: "Kendi Kalesine Gol",
      team1: cards.ownGoals[match.first_team_name] || 0,
      team2: cards.ownGoals[match.second_team_name] || 0,
    },
  ];

  return (
    <div className="match-stats">
      <h3>Maç İstatistikleri</h3>
      <table className="stats-table">
        <thead>
          <tr>
            <th>{match.first_team_name}</th>
            <th></th>
            <th>{match.second_team_name}</th>
          </tr>
        </thead>
        <tbody>
          {statsList.map((stat, index) => (
            <tr key={index}>
              <td>{stat.team1}</td>
              <td>{stat.label}</td>
              <td>{stat.team2}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {matchResults && (
        <div className="head-to-head-summary">
          <h4>Head-to-Head</h4>
          <p>
            {matchResults.firstTeam} vs {matchResults.secondTeam}: {" "}
            {matchResults.firstTeamWins} galibiyet - {matchResults.secondTeamWins} mağlubiyet - {matchResults.draws} beraberlik
          </p>
        </div>
      )}
    </div>
  );
};

export default MatchStats;
